import { useState, useEffect, JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal, useContext, useRef } from "react";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Input, Tooltip, Spinner } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, CheckmarkRegular, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, AddSquare20Regular, Delete20Regular, Settings20Regular, Info16Filled } from "@fluentui/react-icons";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { primaryIcon, secondaryIcon, buttonContent, heightResponsive, parentHome, homeCard, wraperStyle, timezoneInfo, SubSectionResponsive, dashboardTheme, BreadcrumbsBorder, DynamicBoxingCSS } from "../../styles/customStyles";
import { ToastComponent } from "../../components/toast/toast.component";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { DatepickerComponent } from "../../components/picker/datepicker.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { InfoBar } from "../../components/infoBar/infoBar.component";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import DialogBox from "../../components/dialog/dialog.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import validator from '@rjsf/validator-ajv8';
import apiCall from "../../utility/api";
import { Admin_func } from "../../api/administration/admin_func";
import { Form } from "@rjsf/fluent-ui";
import { GlobalContext } from "../../hooks/globalContext";
import { usePermissionStore } from "../../Store/permissionStore";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../utility/utils";
import { AdministrationPages } from "../../components/side_menu/InlineSidenav";

interface iTimezone {
  display: {
    table: string;
    filter: string;
  };
  priority: number;
  key: string;
  name: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode>;
};

interface iMouseEvents {
  currentTarget: {
    style: {
      textDecoration: string;
    };
  };
};

interface iTransformErrors {
  property: any;
  instance: any;
  message: any;
};

interface iGetReviewDataDescription {
  [x: string]: any;
};

export const Roles = () => {
  const contextValue: any = useContext(GlobalContext);
  const formRef = useRef(null);
  const handle = useFullScreenHandle();
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [saveRoleDetails, setSaveRoleDetails]: any = useState(false);
  const [isDeleteRoleToast, setIsDeleteRoleToast] = useState(false);
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [editRoleDetail, setEditRoleDetail] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isDeleteRole, setIsDeleteRole] = useState(false);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [isRoleExist, setIsRoleExist] = useState(false);
  const [messagebar2, setmessagebar2] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [createNewRole, setNewRole] = useState(false);
  const [isfilter, setIsFilter] = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [formDataAdmin, setFormDataAdmin]: any = useState({});
  const [formDataRole, setFormDataRole]: any = useState({});
  const [overLayData, setOverLayData] = useState({});
  const [rowID, setRowID]: any = useState(null);
  const [final_data, set_final_data]: any = useState(null);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [exportData, setExportData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [roleUsers, setUserRoles] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [overlayName, setOverlayName] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [userRoleArray, setUserRoleArray] = useState<string[]>([]);
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [handlePermission, setHandlePermission]: any = useState();
  const [errorMessage, setErrorMessage] = useState<String>('')
  const [isCreatedBy, setCreatedBy] = useState<any[]>([]);

  const { permissions } = usePermissionStore();
  /** @NOTE : These are the permissions used in ROLES */
  const administrationAll = permissions.includes("all");
  const administrationFullAccess = permissions.includes("administration_Fullaccess");
  const administrationReadExport = permissions.includes("administration_ReadandExport");

  var tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');

  useEffect(() => {
    const createdByOptions = uniqueCreatedBy.map((item) => ({ key: item, label: <Caption1> {item} </Caption1> }));
    setCreatedBy(createdByOptions);
    // console.log("Created By Options: ", createdByOptions);
  }, [uniqueCreatedBy]);

  // console.log("Checking the user role array value: ", userRoleArray);
  // console.log("Checking if setIsRoleExist: ", isRoleExist);
  // console.log("Checking message: ", createNewRole);
  // console.log("Delete role toast: ", isDeleteRoleToast);

  let devices: any = [];
  let automation: any = [];
  let apps: any = [];
  let security: any = [];
  let search: any = [];
  let patchmanagement: any = [];

  /** @NOTE : Currently not in use */
  let troubleshoot: any = [];
  let users: any = [];
  let administrationTitle: any = [];

  // Save button
  const saveBtnFunc = () => {
    // console.log("Button clicked: ", formDataRole, 'AND', formDataAdmin);
    // console.log('Checking editRoleDetail: ', editRoleDetail);
    overlayName == 'edit' ? setEditRoleDetail(true) : setSaveRoleDetails(true);
    setIsToast(true);
    setOverlayOpen(false);
  }

  useEffect(() => {
    // console.log("Checking EditRoleDetail: ", editRoleDetail);
  }, [editRoleDetail]);

  useEffect(() => {
    if (!overlayOpen) {
      // console.log("Calling overlay close...");
      setFormDataRole({});
      setFormDataAdmin("");
      // setLoading(true);
      setRowID(null);
      handleEditData({});
    };
  }, [overlayOpen])

  const roleEnum = roleList?.map((role: any) => role?.role);

  const empty = <StackItem> <Text /> </StackItem>;

  // Custom error transformation function
  const transformErrors = (errors) => {
    if (overlayName === 'edit') { return []; }          // Only transform errors if overlayName is not "edit"
    return errors.map((error: iTransformErrors) => {    // Return an empty array to suppress all transformed errors
      const { property, instance } = error;
      return property === '.roleName' ? (instance ? roleEnum.includes(instance) : null) : [];
      // error.message ? 'Role name is required and cannot be empty.' : 'This role already exists. Please choose a different name.';
    });
  };

  // Custom validate function for additional validation
  const customValidate = (formData: any, errors: any) => {
    const { roleName } = formData;
    return roleName && roleEnum.includes(roleName)
      ? (errors.roleName.addError('This role already exists. Please choose a different name.'), errors)
      : errors;
  };

  // Fetch roles once on component mount to populate roleEnum
  useEffect(() => {
    const getRoles = async () => {
      const { data, status } = await apiCall('/users/getRoleList');
      return data && status === 'success' ? setRoleList(data) : null;
    };
    getRoles();
  }, []);

  const handleBothSetMessage = () => {
    setmessagebar2(true);
    setTimeout(() => setmessagebar2(false), 3000);
  };

  const handleFilterArray = (): void => {
    const valueA = dropDownValue1;
    const valueB = dropDownValue2;
    // Check if the column is already filtered
    const columnExists = filterArray.some(filter => filter.startsWith(`${valueA} :`));
    if (!columnExists) {
      const result = `${valueA} : ${valueB}`;
      setFilterArray([...filterArray, result]);
      setIsFilter(true);
      setLoading(true);
      setDropDownValue1('');
      setDropDownValue2('');
    }
  };

  const handleCloseFilter = (index: any): any => {
    // console.log("Clicked...");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    if (updatedArray.length === 0) {
      setIsFilter(false);
      setResetDisabled(true);
    }
    setLoading(true);
  }

  useEffect(() => {
    (filterArray.length > 0) ? setResetDisabled(false) : setResetDisabled(true)
  }, [filterArray])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    // console.log("Entered value: ", enteredValue);
    let name = e.target.name;
    const regexSN = /^[A-Za-z0-9_ -]*$/;
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
      setErrorMessage(`${dropDownValue1} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
    if (name === 'filter' && dropDownValue1 === ("Role Name") || dropDownValue1 === ("Status")) {
      if (regexSN.test(enteredValue)) { setDropDownValue2(enteredValue); }
    }
    // if (name === 'filter' && dropDownValue1 === ("Created By")) { if (regexS.test(enteredValue)) { setDropDownValue2(enteredValue) } }
  }

  const handleOnCLickEdit = (val: any) => {
    const { role } = val;
    // console.log("Role name for edit: ", role);
    // console.log("Overlay name: ", overlayName);
    setSpinnerLoad(true);
    setRowID(role);
    setOverlayName('edit');
    setOverlayOpen(true);
  }

  console.log("spinner",spinnerLoad)

  const [editData, handleEditData]: any = useState({});
  useEffect(() => {
    if (Object.keys(editData).length > 0) {
      // console.log("Inside handleEdit...");
      // console.log("Data: ", editData)l;
      // console.log("Checking editData?.data[0]: ", editData);
      var roleDetails = JSON.parse(editData);
      // console.log('Checking roleDetails: ', roleDetails);
      if (roleDetails != null || roleDetails != undefined) { setFormDataRole(roleDetails) }
      if (handlePermission != null || handlePermission != undefined) { setFormDataAdmin(JSON.parse(handlePermission)) }
    }
  }, [editData, handlePermission])

  const getReviewDataDescription = (formData: iGetReviewDataDescription) => Object.entries(formData || {}).flatMap(([_, sectionValue]) =>
    sectionValue && typeof sectionValue === "object"
      ? Object.entries(sectionValue).map(([key, value]) => permissionDescriptions[key]?.[value] || " ")
      : []
  );

  /** @NOTE : Currently not in use */
  const extraData = () => { // Data table column name code ends here
    const columnPrimary = [
      ["role_name", "Role Name"],
      ["createdOn", "Created On (UTC)"],
      ["modifed_on", "Modified On (UTC)"],
      ["createdOn_timezoned", `Created On (${formattedTimeZone})`],
      ["modifed_on_timezoned", `Modified On (${formattedTimeZone})`],
      ["createdBy", "Created By"],
      ["status", "Status"]
    ].map(([key, label]) => ({ key, label: <Body1Strong> {label} </Body1Strong> }));
    const columnsSecondary = [
      ["role_name", "Role Name"],
      ["createdOn", "Created On"],
      ["last_modified", "Modified On"],
      ["createdBy", "Created By"],
    ].map(([key, label]) => ({ key, label: <Caption1> {label} </Caption1> }));
  };

  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.Administration?.Roles.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "createdOn_timezoned" || val.key === "modifed_on_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label: (
              <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                <StackItem>
                  <Body1Strong>
                    {`${val.name}`}
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ marginLeft: 5, verticalAlign: "text-bottom" }} {...timezoneInfo} />
                    </Tooltip>
                  </Body1Strong>
                </StackItem>
              </Stack>
            )
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }
      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });
    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);
    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Administration?.Roles.filter((val) => val.priority >= 0));
    contextValue.setManageViewPageDetails({ module: "Administration", page: "Roles" });
  }, [contextValue.tableColumnsData]);

  useEffect(() => {
    // console.log("Form data: ", formDataRole);
  }, [formDataRole]);

  const CommonTooltip = ({ children }) => (
    <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
      {children}
    </Tooltip>
  );

  const overFlowContent = () => {
    const addRoleData = () => {
      const rolePermit = administrationAll || administrationFullAccess;

      const handleEnable = () => {
        setFormDataRole({});
        setOverlayOpen(true);
        setOverlayName('');
        setNewRole(false);
        setIsDeleteRoleToast(false)
      };

      const addRoleEnable = (
        <StackItem onClick={handleEnable}>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => {setCurrentPageNo(1); setSpinnerLoad(false)}}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> <AddSquare20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
              <StackItem> <Caption1> Create Role </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
      );

      const addRoleDisable = (
        <CommonTooltip>
          <StackItem>
            <Button shape="circular" appearance="subtle" size="small" disabled>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                <StackItem> <Caption1> Create Role </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
        </CommonTooltip>
      );
      return rolePermit ? addRoleEnable : addRoleDisable;
    };

    const dialogBoxData = () => {
      const handleDisable = isdeletedisabled ? true : false;
      const handleHeader = () => setCurrentPageNo(1);
      const handleFooter = () => {
        setIsDeleteRole(true);
        userActivity('Delete', `{"summary":"${contextValue.selectedRowIdInTable.length} role deleted from Roles"}`);
      }

      const headerData = (
        <Button shape="circular" appearance="transparent" size="small" disabled={handleDisable} onClickCapture={handleHeader}>
          <Stack tokens={{ childrenGap: 5 }} horizontal>
            <StackItem> <Delete20Regular {...(isdeletedisabled ? secondaryIcon : primaryIcon)} /> </StackItem>
            <StackItem> <Caption1> Delete </Caption1> </StackItem>
          </Stack>
        </Button>
      );

      const footerData = (
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          <StackItem> <Button shape="circular" size="small" appearance="primary" onClick={handleFooter}> Confirm </Button> </StackItem>
          <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
        </Stack>
      );

      return (
        <StackItem>
          <DialogBox content="Are you sure you want to delete this role" headerButton={headerData} footer={footerData} />
        </StackItem>
      );
    };

    const refeshData = () => {
      const handleButton = () => {
        setCurrentPageNo(1);
        setIsRefresh(true);
        setLoading(true)
      };
      return (
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleButton}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>
                {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}
              </StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
      )
    };

    const manageViewData = () => {
      const handleButton = () => document.getElementById("manageView").click();
      return (
        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={handleButton}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
      );
    };

    const fullScreenView = () => {
      // const handleButton = () => document.getElementById("manageView").click();
      return (
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink> <FullScreenButton handle={handle} /> </StackItem>
          </Stack>
        </StackItem>
      );
    };

    const verticalDivider = <StackItem ><Divider vertical /> </StackItem>;

    const exportDatas = () => {
      const exportPermit = (administrationAll || administrationReadExport || administrationFullAccess);

      const exportEnable = (
        <StackItem>
          <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_Administration_assignmentlist.csv`}>
          </CSVLink>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); /*userActivity('Export', `{"summary" : "Roles List Exported"}`)*/ }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Export </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
      );

      const exportDisable = (
        <CommonTooltip>
          <Button shape="circular" appearance="subtle" size="small" disabled>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              {empty}
              <StackItem>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                  <StackItem> <Caption1>  Export </Caption1> </StackItem>
                </Stack>
              </StackItem>
            </Stack>
          </Button>
        </CommonTooltip>
      );

      return exportPermit ? exportEnable : exportDisable;
    };

    return (
      <>
        {addRoleData()}
        {verticalDivider}
        {dialogBoxData()}
        {verticalDivider}
        {refeshData()}
        {exportDatas()}
        {manageViewData()}
        {fullScreenView()}
      </>
    );
  };

  // overflow set contents code starts here
  var overFlowComponent = { data: overFlowContent() };
  var tempTableData: any = [];
  var menuLists: any = [];

  useEffect(() => {
    // console.log("First render for fetch roles data...");
    // console.log("Page data for totalPages: ", totalPages);
    // console.log("Page data for totalRecords: ", totalRecords);

    // const fetchUserRoles = async () => {
    //     const rolesWithUsers: any = [];
    //     if (final_data?.data) {
    //         await Promise.all(final_data.data.map(async (val: any) => {
    //             const hasRole = await getUsersThatHaveRole(val.role);
    //             if (hasRole) { rolesWithUsers.push(val.role) };
    //         }));
    //         setUserRoleArray(rolesWithUsers);
    //     }
    // };
    // fetchUserRoles();
  }, [final_data])

  useEffect(() => {
    var tempExportData: any = [];
    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      const { role, born, last, createdBy } = val;
      return tempExportData.push({
        'Role Name': role,
        'Created On': convertToExcelFormat(born),
        'Modifed On': convertToExcelFormat(last),
        'Created By': createdBy
      });
    });
    setExportData(tempExportData);
  }, [exportDetails])

  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueCreatedBy: string[] = [];
      final_data?.data?.forEach((val: any) => {
        const { createdBy } = val;
        if (createdBy && createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(createdBy)) { newUniqueCreatedBy.push(createdBy); }
      });
      setUniqueCreatedBy(newUniqueCreatedBy);
      // console.log("Unique Created By: ", newUniqueCreatedBy);
    } else {
      setUniqueCreatedBy([]);
    }
  }, [final_data]);

  useEffect(() => {
    // console.log("Second render for table data...");
    // console.log("Final data: ", final_data);
    // setmessagebar2(false);
    // Data table values append code starts here

    (final_data !== undefined && final_data !== null)
      ? final_data?.data?.map((val: any, i: any) => {
        // console.log("I'm inside...");
        menuLists.push();

        const accessPermit = administrationAll || administrationFullAccess;
        // console.log("Third Render inside FinalData: ", userRoleArray);
        const { role, born, last, createdBy, isAssigned, assignedUsers } = val;

        const whenTrue = () => {
          const trueButton = (
            <Button
              size="small"
              appearance="transparent"
              onMouseEnter={(e: iMouseEvents) => e.currentTarget.style.textDecoration = 'underline'}
              onMouseLeave={(e: iMouseEvents) => e.currentTarget.style.textDecoration = 'none'}
              onClick={(e: any) => { handleOnCLickEdit(val) }}
              style={buttonContent}
            >
              {role}
            </Button>
          );
          return tempTableData.push({
            id: role,
            checkbox: isAssigned ? 'hide' : 'show',
            role_name: { id: i, label: trueButton },
            createdOn: { label: <Caption1> {(born !== null && born !== " ") ? convertUTCToReadableFormat(born) : "-"} </Caption1> },
            createdOn_timezoned: { label: <Caption1> {(born !== null && born !== " ") ? convertToLocalTimezone(born, userTimeZone) : "-"} </Caption1> },
            modifed_on: { label: <Caption1> {(last !== null && last !== " ") ? convertUTCToReadableFormat(last) : "-"} </Caption1> },
            modifed_on_timezoned: { label: <Caption1> {(last !== null && last !== " ") ? convertToLocalTimezone(last, userTimeZone) : "-"} </Caption1> },
            createdBy: { label: <Caption1> {createdBy} </Caption1> },
            status: { label: <Caption1> {(isAssigned ? `Assigned to ${assignedUsers.length} Users` : "Not Assigned")} </Caption1> }
          });
        };

        const whenFalse = () => {
          const falseButton = (
            <CommonTooltip>
              <Button appearance="transparent" size="small" style={buttonContent}>
                {role}
              </Button>
            </CommonTooltip>
          );
          return tempTableData.push({
            id: role,
            checkbox: 'hide',
            role_name: { icon: "", id: i, label: falseButton },
            createdOn: { label: <Caption1> {(born !== null && born !== " ") ? convertUTCToReadableFormat(born) : "-"} </Caption1> },
            createdOn_timezoned: { label: <Caption1> {(born !== null && born !== " ") ? convertToLocalTimezone(born, userTimeZone) : "-"} </Caption1> },
            modifed_on: { label: <Caption1> {(last !== null && last !== " ") ? convertUTCToReadableFormat(last) : "-"} </Caption1> },
            modifed_on_timezoned: { label: <Caption1> {(last !== null && last !== " ") ? convertToLocalTimezone(last, userTimeZone) : "-"} </Caption1> },
            createdBy: { label: <Caption1> {createdBy} </Caption1> },
            status: { label: <Caption1> {isAssigned ? `Assigned to ${assignedUsers.length} Users` : "Not Assigned"} </Caption1> }
          })
        };

        return accessPermit ? whenTrue() : whenFalse();
      })
      : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
      if (isRefresh) {
        console.log("FIRST CALL");
        setIsRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
          setRefreshToast(false);
        }, 3000);
      }
    }, 500);
  }, [final_data, permissions]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  // Data table values append code ends here
  useEffect(() => {
    const sections = { devices, automation, apps, troubleshoot, administrationTitle, security, patchmanagement, search };
    Object.entries(sections).forEach(([sectionKey, sectionArray]) =>
      sectionArray.push(...(formDataAdmin?.[sectionKey] ? Object.values(formDataAdmin[sectionKey]) : []))
    );

    const overlayHeader = overlayName === 'edit' ? <Title3> Edit {rowID} Role </Title3> : <Title3> Create Role </Title3>;

    const introductionData = (
      spinnerLoad ?
        <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner />
        </Stack> :
        <>
          <Form
            ref={formRef}
            formData={formDataRole}
            schema={jsonSchemaRole}
            uiSchema={uiSchemaRole}
            validator={validator}
            liveValidate={true}
            disabled={overlayName === 'edit'}
          onChange={(e) => setFormDataRole(e.formData)}
          customValidate={overlayName !== 'edit' ? customValidate : undefined} // Conditionally apply customValidate
          transformErrors={transformErrors} // Conditionally transform errors based on overlayName within the function itself
        />
        <Stack tokens={{ childrenGap: 15, padding: '15px 0px 0px 0px' }}>
          <InfoBar title="These are the basic details  associated with this Roles. You can retain them or modify them to suit your specific use case." />
          <StackItem> <Body1Strong> What is the benefit? </Body1Strong> </StackItem>
          <StackItem>
            <Body1 align='justify'> Creating roles involves defining sets of permissions and access levels that determine what actions users with that role can perform within a system or organization. These permissions can include tasks like viewing, creating, editing, or deleting certain data or functionalities. Roles help enforce security, streamline workflows, and ensure that users only have access to the resources necessary for their responsibilities, reducing the risk of unauthorized access or misuse of sensitive information. </Body1>
          </StackItem>
        </Stack>
      </>
    );

    const permissionData = (
      <div>
        <Form // ref = {formRef} // widgets={CustomWidgets} 
          formData={formDataAdmin}
          schema={jsonSchemaPermisssion}
          uiSchema={uiSchemaPermission}
          validator={validator}
          onChange={(e) => setFormDataAdmin(e.formData)}
        />
      </div>
    );

    const rolesDetailsData = (
      <Stack tokens={{ childrenGap: 20 }}>
        <StackItem> <Body1Strong> Role Assigned To Users </Body1Strong> </StackItem>
        <StackItem>
          {roleUsers && roleUsers.map((item: any) => <StackItem key={item}> {<CheckmarkRegular {...primaryIcon} />}{" "}{item} </StackItem>)}
        </StackItem>
      </Stack>
    );

    const reviewData = (
      <Stack>
        {Object.entries(sections).map(([sectionKey, sectionArray]) => (
          sectionArray.length > 0 && (
            <Stack key={sectionKey} id={sectionKey}>
              <StackItem> <Body1Strong> {sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1)} </Body1Strong> </StackItem>
              <StackItem>
                <Stack>
                  {getReviewDataDescription({ [sectionKey]: formDataAdmin[sectionKey] }).map((desc, index) => (
                    <Stack horizontal key={index} tokens={{ childrenGap: 5 }}>
                      <StackItem> <CheckmarkRegular {...primaryIcon} /> </StackItem>
                      <StackItem> <p> {desc} </p> </StackItem>
                    </Stack>
                  ))}
                </Stack>
              </StackItem>
            </Stack>
          )
        ))}
      </Stack>
    );

    setOverLayData({
      headerTitle: overlayHeader,
      size: "large",
      isTabs: true,
      tabItems: {
        Introduction: introductionData,
        Permission: permissionData,
        ...(overlayName === "edit" && { "Role Details": rolesDetailsData }),
        "Review Data": reviewData
      }
    })

    // console.log("JSON schema: ", jsonSchemaPermisssion)
  }, [formDataRole, formDataAdmin, overlayName, spinnerLoad, rowID]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
    contextValue.setSelectedRowIdInSubTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

  useEffect(() => {
    if (saveBtnClicked) {
      setOverlayOpen(false);
      handleBothSetMessage();
    }
  }, [saveBtnClicked]);

  const userActivity = (action: String, activity: String, status: any = 'success') => {
    // setUserActivityData({ pageName: 'Roles', moduleName: "Administration", action: action, time: Math.floor(Date.now() / 1000), activity: activity, status: status });
    // setTracker(true);
  }

  const breadcrumbsData = (
    <StackItem grow shrink>
      <Stack horizontalAlign="start">
        <StackItem grow shrink> <Breadcrumbs pageName="Administration" subPageName="" subPageLink="#" /> </StackItem>
      </Stack>
    </StackItem>
  );

  // const fullScreenView = (
  //   <StackItem grow shrink>
  //     <Stack horizontalAlign="end">
  //       <StackItem grow shrink> <FullScreenButton handle={handle} /> </StackItem>
  //     </Stack>
  //   </StackItem>
  // );

  const rolesPageData = () => {
    const sideMenuData = () => (
      <SideMenu
        leftOpenSubMenu={leftOpenSubMenu}
        setleftOpenSubMenu={setleftOpenSubMenu}
        menuItems={AdministrationPages("Roles")}
      />
    );

    const overFlowData = (
      <StackItem>
        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
        <Divider />
      </StackItem>
    );

    const searchBarData = (
      <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch="Role" searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
    );

    const tableOptions = () => {
      const menuData = () => {
        const menuButton = (
          <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
              <Body1> Filter </Body1>
            </Stack>
          </MenuButton>
        );

        const menuItem = () => {
          const dropdownData = (
            <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
          );

          const modifiedData = (dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? <span style={{ color: 'red' }}>This column is already filtered</span> : <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />);

          const roleData = (dropDownValue1 === "Role Name" /*|| dropDownValue1 === "Created By" */ || dropDownValue1 === "Status") && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? <span style={{ color: 'red' }}>This column is already filtered</span> : <Input size="small" onChange={inputChange} name="filter" value={dropDownValue2} />);

          const createdData = dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? <span style={{ color: 'red' }}>This column is already filtered</span> : <DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />);

          const buttonsData = () => {
            const handleDisable = !dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`));
            const handleApply = () => { handleFilterArray(); setFilterMenuOpen(false); };
            const handleCancel = () => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); };
            return (
              <Stack tokens={{ childrenGap: 10 }} horizontal>
                <StackItem>
                  <Button shape="circular" appearance="primary" disabled={handleDisable} onClick={handleApply}>
                    <Caption1> Apply </Caption1>
                  </Button>
                </StackItem>
                <StackItem>
                  <Button shape="circular" onClick={handleCancel}>
                    <Caption1> Cancel </Caption1>
                  </Button>
                </StackItem>
              </Stack>
            );
          };

          const dividerData = <StackItem> <Divider /> </StackItem>;

          return (
            <>
              <Body1Strong> Add a Filter </Body1Strong>
              <Divider />
              <MenuList>
                <Stack tokens={{ childrenGap: 5 }}>
                  {empty}
                  <StackItem> <Caption1> Filter </Caption1> </StackItem>
                  {dropdownData}
                  {dividerData}
                  <StackItem> <Caption1> Value </Caption1> </StackItem>
                  {modifiedData}
                  {roleData}
                  {createdData}
                  {dividerData}
                  {buttonsData()}
                </Stack>
              </MenuList>
            </>
          );
        }

        return <StackItem> <MenuDropdown open={filterMenuOpen} btn={menuButton} itemVal={menuItem()} /> </StackItem>
      };

      const resetFilter = () => {
        const handleClick = () => {
          setFilterArray([]);
          setIsFilter(false);
          setDropDownValue2('');
          setDropDownValue1('');
          setResetDisabled(true);
          setLoading(true);
        };
        return (
          <StackItem onClick={handleClick}>
            <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <FilterDismiss20Filled /> </StackItem>
                <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
        );
      };

      const paginationData = (tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>;

      const filterArrayData = () => (
        <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
          <StackItem>
            {filterArray.length > 0 && (
              <Stack horizontal wrap>
                {filterArray.map((item, index) => (
                  <Button size="small" shape="circular">
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                      <StackItem>
                        <Stack tokens={{ childrenGap: 1 }}>
                          {empty}
                          <StackItem> <Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /> </StackItem>
                        </Stack>
                      </StackItem>
                    </Stack>
                  </Button>
                ))}
              </Stack>
            )}
          </StackItem>

          <StackItem disableShrink>
            {(tableData.length > 0 && !loading) && (
              totalRecords > 0 &&
              <Caption1>
                Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
              </Caption1>
            )}
          </StackItem>
        </Stack>
      );

      // const countData = (tableData.length > 0 && !loading) && <Stack horizontal enableScopedSelectors horizontalAlign="space-between">
      //   <StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
      // </Stack>;

      const infoData = <InfoBar showSpaces={true} title="Creating roles involves defining sets of permissions and access levels that determine what actions users with the assigned role can perform. Role creation options include None (no access), Read (view only), Read and Export (view and export), and Full Access (view, export, and perform Create, Read, Edit, and Delete operations), ensuring appropriate access control based on user responsibilities." />;

      return (
        <StackItem style={wraperStyle}>
          <StackItem>
            <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
              <Stack horizontal tokens={{ childrenGap: 10 }}>
                <StackItem>
                  {searchBarData}
                </StackItem>
                {menuData()}
                {resetFilter()}
              </Stack>
              {paginationData}
            </Stack>
            {filterArrayData()}
          </StackItem>
          {infoData}
          {/* {countData} */}
        </StackItem>
      );
    };

    const rolesTableData = () => (
      <Admin_func filterArray={filterArray} data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} rowID={rowID} setRowID={setRowID} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} formDataRole={formDataRole} setFormDataRole={setFormDataRole} formDataAdmin={formDataAdmin} setFormDataAdmin={setFormDataAdmin} saveRoleDetails={saveRoleDetails} setDeleteDisabled={setDeleteDisabled} setSaveRoleDetails={setSaveRoleDetails} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} editRoleDetail={editRoleDetail} setEditRoleDetail={setEditRoleDetail} isDeleteRole={isDeleteRole} setIsDeleteRole={setIsDeleteRole} handleEditData={handleEditData} setExportDetails={setExportDetails} setIsRefresh={setIsRefresh} setIsToast={setIsToast} isRefresh={isRefresh} setRefreshToast={setRefreshToast} roleUsers={roleUsers} setIsDeleteRoleToast={setIsDeleteRoleToast} isDeleteRoleToast={isDeleteRoleToast} setNewRole={setNewRole} createNewRole={createNewRole} setHandlePermission={setHandlePermission} handlePermission={handlePermission} setUserRoles={setUserRoles} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} setIsRoleExist={setIsRoleExist} setLoading={setLoading} setUserRoleArray={setUserRoleArray} setSpinnerLoad={setSpinnerLoad}/>
    );

    const loadingData = () => {
      return loading
        ? <SkeletonDataTable />
        : (tableData.length > 0)
          ? <DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen} />
          : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem> <Text size={500}> No result. </Text> </StackItem>
          </Stack>
    };

    const overlayDatas = (
      <OverLay formRef={formRef} overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} isNavBtn={true} saveBtnFunc={saveBtnFunc} pagename="roles" />
    );

    return (
      <FluentProvider style={parentHome} theme={dashboardTheme}>
        <Stack style={parentHome}>
          <StackItem grow shrink style={BreadcrumbsBorder}>
            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
              {empty}
              <StackItem grow shrink>
                <Breadcrumbs items={[
                  { name: "Manage", link: "/home" },
                  { name: "Administration", link: "#" },
                  { name: "Roles", link: "#" },
                ]} />
              </StackItem>
            </Stack>
          </StackItem>
          {/* {pageInfo} */}
          <Stack horizontal style={heightResponsive}>
            {sideMenuData()}
            <StackItem>
              {empty}
              <Stack tokens={{ childrenGap: 1 }}>{empty}{empty}</Stack>
              <Stack tokens={{ childrenGap: 10 }} style={{ height: '-webkit-fill-available' }}>
                {overFlowData}
                {tableOptions()}
                {rolesTableData()}
                {loadingData()}
              </Stack>
            </StackItem>
          </Stack>
          {overlayDatas}
        </Stack>
      </FluentProvider>
    );
  };

  const createNewRoleData = createNewRole && (
    <ToastComponent setmessagebar={setmessagebar2} isToastEnabled={messagebar2} toastIntent="success" position="top-end" title="Success" message="New Role Created Successfully" footer="" />
  );

  const isRoleExistData = isRoleExist && (
    <ToastComponent setmessagebar={setIsToast} isToastEnabled={isRoleExist} toastIntent="warning" position="top-end" title="Failed" message={'Role already exists!'} footer="" />
  );

  const isDeleteRoleToastData = isDeleteRoleToast && (
    <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message="Role Deleted Successfully" footer="" />
  );

  const refreshToastData = refreshToast && (
    <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />
  );

  const overlayNameData = overlayName == "edit" && editRoleDetail && (
    <ToastComponent setmessagebar={setmessagebar2} isToastEnabled={messagebar2} toastIntent="success" position="top-end" title="Success" message="Role Edited Successfully" footer="" />
  );

  return (
    <FullScreen handle={handle} className="fullScreenBackgroundColor">
      <StackItem grow shrink> <Stack tokens={{ childrenGap: 10 }} horizontal> {breadcrumbsData} </Stack> </StackItem>
      <Stack tokens={{ childrenGap: 20 }} horizontal style={parentHome}>
        <StackItem style={parentHome}> {rolesPageData()} </StackItem>
        {createNewRoleData}
        {isRoleExistData}
        {isDeleteRoleToastData}
        {refreshToastData}
        {overlayNameData}
        {empty}
      </Stack>
    </FullScreen>
  );
};

// ---------------------------------------------------------------------------------------------------- // 
/** @NOTE : This below function is used to create a custom json template */
interface iCustomRadioWidget {
  options: any;
  value: any;
  required: any;
  disabled: any;
  onChange: any;
  label: any
}

interface iCustomRadioWidgetOption {
  value: string | number | readonly string[] | undefined;
  label: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined;
}

type tCustomRadioWidgetOption = Key | null | undefined;

const CustomRadioWidget = (props: iCustomRadioWidget) => {
  const { options, value, required, disabled, onChange, label } = props;
  const empty = <StackItem><Text /></StackItem>;
  return (
    <div>
      <Stack horizontal styles={{ root: { justifyContent: 'space-between', paddingRight: '36.5%' } }}>
        <StackItem><Body1Strong><label> {label} </label></Body1Strong></StackItem>
        <StackItem>
          {options.enumOptions.map((option: iCustomRadioWidgetOption, index: tCustomRadioWidgetOption) => {
            const { value: inputOption, label: inputLabel } = option;
            return (
              <label key={index} style={{ marginRight: '10px' }}>
                <input
                  type="radio"
                  value={inputOption}
                  required={required}
                  disabled={disabled}
                  checked={value === inputOption}
                  onChange={() => onChange(inputOption)}
                />
                {inputLabel}
              </label>
            )
          })}
        </StackItem>
      </Stack>
      <Stack tokens={{ childrenGap: 10 }}>{empty}{empty}{empty}</Stack>
    </div>
  );
};

/** @NOTE : These below are the JSON */
const jsonSchemaPermisssion: any = {
  "type": "object",
  "properties": {
    "devices": {
      "title": "Devices",
      "type": "object",
      "properties": {
        "overview": {
          "type": "string",
          "title": "Overview",
          "enum": [
            "none",
            "overview_Read",
            "overview_ReadandExport",
            "overview_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "deviceClassification": {
          "type": "string",
          "title": "Device Classification",
          "enum": [
            "none",
            "deviceClassification_Read",
            "deviceClassification_ReadandExport",
            "deviceClassification_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "monitor": {
          "type": "string",
          "title": "Monitor",
          "enum": [
            "none",
            "monitor_Read",
            "monitor_ReadandExport",
            "monitor_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "remediation": {
          "type": "string",
          "title": "Assignment",
          "enum": [
            "none",
            "remediation_Read",
            "remediation_ReadandExport",
            "remediation_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "compPolicies": {
          "type": "string",
          "title": "Compliance Policies",
          "enum": [
            "none",
            "compPolicies_Read",
            "compPolicies_ReadandExport",
            "compPolicies_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "conditionalAccess": {
          "type": "string",
          "title": "Conditional Access",
          "enum": [
            "none",
            "conditionalAccess_Read",
            "conditionalAccess_ReadandExport",
            "conditionalAccess_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "userSurveys": {
          "type": "string",
          "title": "User Surveys",
          "enum": [
            "none",
            "userSurveys_Read",
            "userSurveys_ReadandExport",
            "userSurveys_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "dataCollection": {
          "type": "string",
          "title": "Data Collection",
          "enum": [
            "none",
            "dataCollection_Read",
            "dataCollection_ReadandExport",
            "dataCollection_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "activityLog": {
          "type": "string",
          "title": "Activity Log",
          "enum": [
            "none",
            "activityLog_Read",
            "activityLog_ReadandExport"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export"
          ]
        }
      }
    },
    "automation": {
      "title": "Automation",
      "type": "object",
      "properties": {
        "allAutomation": {
          "type": "string",
          "title": "All Automation",
          "enum": [
            "none",
            "allAutomation_Read",
            "allAutomation_ReadandExport",
            "allAutomation_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "configuration": {
          "type": "string",
          "title": "Automation",
          "enum": [
            "none",
            "configuration_Read",
            "configuration_ReadandExport",
            "configuration_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "selfHelp": {
          "type": "string",
          "title": "Self-Help",
          "enum": [
            "none",
            "selfHelp_Read",
            "selfHelp_ReadandExport",
            "selfHelp_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "autoheal": {
          "type": "string",
          "title": "Autoheal",
          "enum": [
            "none",
            "autoheal_Read",
            "autoheal_ReadandExport",
            "autoheal_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "automationSchedule": {
          "type": "string",
          "title": "Automation Scheduler",
          "enum": [
            "none",
            "automationSchedule_Read",
            "automationSchedule_ReadandExport",
            "automationSchedule_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "automationUserSurveys": {
          "type": "string",
          "title": "User Surveys",
          "enum": [
            "none",
            "automationUserSurveys_Read",
            "automationUserSurveys_ReadandExport",
            "automationUserSurveys_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "automationCompPolicies": {
          "type": "string",
          "title": "Compliance Policies",
          "enum": [
            "none",
            "automationCompPolicies_Read",
            "automationCompPolicies_ReadandExport",
            "automationCompPolicies_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "alert": {
          "type": "string",
          "title": "Alert",
          "enum": [
            "none",
            "alert_Read",
            "alert_ReadandExport",
            "alert_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "automationLog": {
          "type": "string",
          "title": "Activity Log",
          "enum": [
            "none",
            "automationLog_Read",
            "automationLog_ReadandExport"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export"
          ]
        }
      }
    },
    "apps": {
      "title": "Apps",
      "type": "object",
      "properties": {
        "appInstall": {
          "type": "string",
          "title": "Deploy App Install",
          "enum": [
            "none",
            "appInstall_Read",
            "appInstall_ReadandExport",
            "appInstall_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "appUnInstall": {
          "type": "string",
          "title": "Deploy App Uninstall",
          "enum": [
            "none",
            "appUnInstall_Read",
            "appUnInstall_ReadandExport",
            "appUnInstall_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "discoverApps": {
          "type": "string",
          "title": "Discovered Apps",
          "enum": [
            "none",
            "discoverApps_Read",
            "discoverApps_ReadandExport"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export"
          ]
        },
        "appStatus": {
          "type": "string",
          "title": "Status",
          "enum": [
            "none",
            "appStatus_Read",
            "appStatus_ReadandExport",
            "appStatus_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "appLog": {
          "type": "string",
          "title": "Activity Log",
          "enum": [
            "none",
            "appLog_Read",
            "appLog_ReadandExport"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export"
          ]
        },
        "appMonitored": {
          "type": "string",
          "title": "App Monitored",
          "enum": [
            "none",
            "appMonitored_Read",
            "appMonitored_ReadandExport",
            "appMonitored_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "appInstallation": {
          "type": "string",
          "title": "App Installation",
          "enum": [
            "none",
            "appInstallation_Read",
            "appInstallation_ReadandExport",
            "appInstallation_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "appUnInstallProfile": {
          "type": "string",
          "title": "App Uninstall Profile",
          "enum": [
            "none",
            "appUnInstallProfile_Read",
            "appUnInstallProfile_ReadandExport",
            "appUnInstallProfile_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "appProtectProfile": {
          "type": "string",
          "title": "Device Protection Policies",
          "enum": [
            "none",
            "appProtectProfile_Read",
            "appProtectProfile_ReadandExport",
            "appProtectProfile_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        }
      }
    },
    "troubleshoot": {
      "type": "object",
      "title": "Troubleshoot",
      "properties": {
        "tshootAlert": {
          "type": "string",
          "title": "Alert",
          "enum": [
            "none",
            "tshootAlert_Read",
            "tshootAlert_ReadandExport",
            "tshootAlert_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "tshoot": {
          "type": "string",
          "title": "Troubleshoot",
          "enum": [
            "none",
            "tshoot_Read",
            "tshoot_ReadandExport",
            "tshoot_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "status": {
          "type": "string",
          "title": "Status",
          "enum": [
            "none",
            "status_Read",
            "status_ReadandExport",
            "status_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "tshoot_compliancepolicy": {
          "type": "string",
          "title": "Compliance Policy",
          "enum": [
            "none",
            "tshoot_compliancepolicy_Read",
            "tshoot_compliancepolicy_ReadandExport",
            "tshoot_compliancepolicy_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        }
      }
    },
    "search": {
      "title": "Search",
      "type": "object",
      "properties": {
        "asset": {
          "type": "string",
          "title": "Asset",
          "enum": [
            "none",
            "asset_Read",
            "asset_ReadandExport",
            "asset_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "event": {
          "type": "string",
          "title": "Event",
          "enum": [
            "none",
            "event_Read",
            "event_ReadandExport",
            "event_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        }
      }
    },
    "administrationTitle": {
      "type": "object",
      "title": "Administration",
      "properties": {
        "administration": {
          "type": "string",
          "title": "Role",
          "enum": [
            "none",
            "administration_Read",
            "administration_ReadandExport",
            "administration_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "allUsers": {
          "type": "string",
          "title": "Users",
          "enum": [
            "none",
            "allUsers_Read",
            "allUsers_ReadandExport",
            "allUsers_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "tenant": {
          "type": "string",
          "title": "Tenant",
          "enum": [
            "none",
            "tenant_Read",
            "tenant_ReadandExport",
            "tenant_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "approvals": {
          "type": "string",
          "title": "SSO",
          "enum": [
            "none",
            "approvals_Read",
            "approvals_ReadandExport",
            "approvals_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        /*
        "ssoConfiguration": {
            "type": "string",
            "title": "Configuration",
            "enum": [
                "none",
                "ssoConfiguration_Read",
                "ssoConfiguration_ReadandExport",
                "ssoConfiguration_Fullaccess"
            ],
            "enumNames": [
                "None",
                "Read",
                "Read and export",
                "Full Access"
            ]
        },
        */
        "administrationLog": {
          "type": "string",
          "title": "Activity Log",
          "enum": [
            "none",
            "administrationLog_Read",
            "administrationLog_ReadandExport"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export"
          ]
        }
      }
    },
    "patchmanagement": {
      "type": "object",
      "title": "Patch Management",
      "properties": {
        "patchDetection": {
          "type": "string",
          "title": "Patch Detection",
          "enum": [
            "none",
            "patchDetection_Read",
            "patchDetection_ReadandExport",
            "patchDetection_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        }
      }
    },
    "security": {
      "title": "Security",
      "type": "object",
      "properties": {
        "security_dataCollection": {
          "type": "string",
          "title": "Data Collection",
          "enum": [
            "none",
            "security_dataCollection_Read",
            "security_dataCollection_ReadandExport",
            "security_dataCollection_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "security_compliancepolicy": {
          "type": "string",
          "title": "Compliance Policy",
          "enum": [
            "none",
            "security_compliancepolicy_Read",
            "security_compliancepolicy_ReadandExport",
            "security_compliancepolicy_Fullaccess"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export",
            "Full Access"
          ]
        },
        "security_activityLog": {
          "type": "string",
          "title": "Activity Log",
          "enum": [
            "none",
            "security_activityLog_Read",
            "security_activityLog_ReadandExport"
          ],
          "enumNames": [
            "None",
            "Read",
            "Read and export"
          ]
        }
      }
    }
  }
};

const uiSchemaPermission: any = {
  "devices": {
    "overview": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "deviceClassification": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "monitor": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "remediation": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "compPolicies": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "conditionalAccess": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "userSurveys": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "dataCollection": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "activityLog": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    }
  },
  "automation": {
    "allAutomation": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "autoheal": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "automationSchedule": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "automationUserSurveys": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "automationCompPolicies": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "automationLog": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "alert": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "selfHelp": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "configuration": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    }
  },
  "apps": {
    "appMonitored": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "appInstall": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "appUnInstall": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "discoverApps": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "appStatus": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "appLog": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "appInstallation": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "appUnInstallProfile": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "appProtectProfile": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    }
  },
  "troubleshoot": {
    "tshootAlert": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "tshoot": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "status": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "tshoot_": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "tshoot_compliancepolicy": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    }
  },
  "search": {
    "asset": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "event": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    }
  },
  "administrationTitle": {
    "administration": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "allUsers": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "tenant": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "administrationLog": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "approvals": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "ssoConfiguration": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    }
  },
  "security": {
    "security_dataCollection": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "security_compliancepolicy": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    },
    "security_activityLog": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    }
  },
  "patchmanagement": {
    "patchDetection": {
      "ui:widget": CustomRadioWidget,
      "ui:inline": true
    }
  },
  'ui:submitButtonOptions': {
    norender: true,
  },
  "ui:order": [
    "devices",
    "overview",
    "deviceClassification",
    "monitor",
    "remediation",
    "compPolicies",
    "conditionalAccess",
    "userSurveys",
    "dataCollection",
    "activityLog",
    "automation",
    "allAutomation",
    "autoheal",
    "automationSchedule",
    "automationUserSurveys",
    "automationCompPolicies",
    "automationLog",
    "alert",
    "selfHelp",
    "configuration",
    "apps",
    "appMonitored",
    "appInstall",
    "appUnInstall",
    "discoverApps",
    "appStatus",
    "appLog",
    "appInstallation",
    "appUnInstallProfile",
    "appProtectProfile",
    "troubleshoot",
    "tshootAlert",
    "tshoot",
    "status",
    "tshoot_compliancepolicy",
    "search",
    "asset",
    "event",
    "administrationTitle",
    "administration",
    "allUsers",
    "tenant",
    "administrationLog",
    "approvals",
    "ssoConfiguration",
    "security",
    "security_dataCollection",
    "security_compliancepolicy",
    "security_activityLog",
    "patchmanagement",
    "patchDetection"
  ]
};

const jsonSchemaRole: any = {
  "type": "object",
  "properties": {
    "roleName": {
      "type": "string",
      "title": "Name"
    }
  },
  "required": ["roleName"]
};

const uiSchemaRole: any = {
  "roleName": {
    "ui:placeholder": ""
  },
  "benefit": {
    "ui:widget": "textarea",
    "ui:options": {
      "rows": 4
    }
  },
  "impact": {
    "ui:widget": "textarea",
    "ui:options": {
      "rows": 4
    }
  },
  'ui:submitButtonOptions': {
    norender: true,
  }
};
// ---------------------------------------------------------------------------------------------------- // 

const permissionDescriptions = {
  // Device pages
  overview: {
    none: "No access to the overview.",
    overview_Read: "Read-only access to the overview.",
    overview_ReadandExport: "Read and export data from the overview.",
    overview_Fullaccess: "Full access to the overview with the ability to add, edit, delete, and export data."
  },
  deviceClassification: {
    none: "No access to device classification.",
    deviceClassification_Read: "Read-only access to device classification.",
    deviceClassification_ReadandExport: "Read and export data from device classification.",
    deviceClassification_Fullaccess: "Full access to device classification with the ability to add, edit, delete, and export data."
  },
  monitor: {
    none: "No access to Monitor.",
    monitor_Read: "Read-only access to Monitor.",
    monitor_ReadandExport: "Read and export data from Monitor.",
    monitor_Fullaccess: "Full access to Monitor with ability to export data and attach/detach alerts to all devices or specific device classifications."
  },
  remediation: {
    none: "No access to Assignment.",
    remediation_Read: "Read-only access to Assignment.",
    remediation_ReadandExport: "Read and export data from Assignment.",
    remediation_Fullaccess: "Full access to remediation assignment with ability to export data and attach/detach Selfhelp, Proactive, Scheduler, and Autoheal to all devices or specific device classifications."
  },
  compPolicies: {
    none: "No access to Compliance Policies.",
    compPolicies_Read: "Read-only access to Compliance Policies.",
    compPolicies_ReadandExport: "Read and export data from Compliance Policies.",
    compPolicies_Fullaccess: "Full access to Compliance Policies with ability to export data and attach/detach compliance Policies to all devices or specific device classifications."
  },
  conditionalAccess: {
    none: "No access to Conditional Access",
    conditionalAccess_Read: "Read-only access to Conditional Access.",
    conditionalAccess_ReadandExport: "Read and export data from Conditional Access.",
    conditionalAccess_Fullaccess: "Full access to Conditional Access, with ability to export data and attach/detach Conditional Access to all devices or specific device classifications."
  },
  userSurveys: {
    none: "No access to User Survey",
    userSurveys_Read: "Read-only access to User Surveys.",
    userSurveys_ReadandExport: "Read and export data from User Surveys.",
    userSurveys_Fullaccess: "Full access to user surveys with ability to export data and attach/detach User Survey to all devices or specific device classifications."
  },
  dataCollection: {
    none: "No access to Data Collection",
    dataCollection_Read: "Read-only access to Data Collection.",
    dataCollection_ReadandExport: "Read and export data from Data Collection.",
    dataCollection_Fullaccess: "Full access to Data Collection with ability to export data and attach/detach Data Collection to all devices or specific device classifications."
  },
  activityLog: {
    none: "No access to Activity Log",
    activityLog_Read: "Read-only access to Activity log.",
    activityLog_ReadandExport: "Read and export data from Activity Logs."
  },
  // Automate pages
  allAutomation: {
    none: "No access to All Automations",
    allAutomation_Read: "Read-only access to All Automations.",
    allAutomation_ReadandExport: "Read and export data from All Automations.",
    allAutomation_Fullaccess: "Full access to All Automations."
  },
  configuration: {
    none: "No access to Automation",
    configuration_Read: "Read-only access to Automation.",
    configuration_ReadandExport: "Read and export data from Automation.",
    configuration_Fullaccess: "Full access to Automation with ability to export data and create individual automation tasks that can be effortlessly integrated and executed in sequence across features like Self-help, Proactive, Autoheal, and Scheduler"
  },
  selfHelp: {
    none: "No access to Self-Help / Proactive",
    selfHelp_Read: "Read-only access to Self-Help / Proactive.",
    selfHelp_ReadandExport: "Read and export data from Self-Help / Proactive.",
    selfHelp_Fullaccess: "Full access to Self-Help / Proactive with ability to export data and create Self-Help / Proactive, By combining the automations developed in the automaion section, comprehensive Self-help and Proactive solutions can be created."
  },
  autoheal: {
    none: "No access to Autoheal",
    autoheal_Read: "Read-only access to Autoheal.",
    autoheal_ReadandExport: "Read and export data from Autoheal.",
    autoheal_Fullaccess: "Full access to  Autoheal with ability to export data and create Autoheal which automatically triggers when predefined conditions,are detected, By combining the automations developed in the automaion section, comprehensive Autoheal solutions can be created."
  },
  automationSchedule: {
    none: "No access to Automation Scheduler",
    automationSchedule_Read: "Read-only access to automation schedules.",
    automationSchedule_ReadandExport: "Read and export data from automation schedules.",
    automationSchedule_Fullaccess: "Full access to  Automation Scheduler with ability to export data and create Automation Scheduler which executes tasks at a predefined, scheduled time."
  },
  automationUserSurveys: {
    none: "No access to User Surveys",
    automationUserSurveys_Read: "Read-only access to User Surveys.",
    automationUserSurveys_ReadandExport: "Read and export data from User Surveys.",
    automationUserSurveys_Fullaccess: "Full access to User Surveys."
  },
  automationCompPolicies: {
    none: "No access to Compliance policies",
    automationCompPolicies_Read: "Read-only access to Compliance policies.",
    automationCompPolicies_ReadandExport: "Read and export data from Compliance Policies.",
    automationCompPolicies_Fullaccess: "Full access to Compliance policies with ability to export data and create group policies."
  },
  alert: {
    none: "No access to Alerts",
    alert_Read: "Read-only access to Alerts.",
    alert_ReadandExport: "Read and export data from Alerts.",
    alert_Fullaccess: "Full access to Alerts with ability to export data and create Alerts."
  },
  automationLog: {
    none: "No access to Activity Log",
    automationLog_Read: "Read-only access to Activity log.",
    automationLog_ReadandExport: "Read and export data from Activity logs."
  },
  // Apps pages
  appMonitored: {
    none: "No access to Apps Monitored",
    appMonitored_Read: "Read-only access to Apps Monitored",
    appMonitored_ReadandExport: "Read and export data from Apps Monitored",
    appMonitored_Fullaccess: "Full access to Apps Monitored with ability to export data and create applications which should be monioted for CPU, Memory and Network"
  },
  appInstallation: {
    none: "No access to App Install Profile",
    appInstallation_Read: "Read-only access to App Install Profile",
    appInstallation_ReadandExport: "Read and export data from App Install Profile",
    appInstallation_Fullaccess: "Full access to App Install Profile with ability to export data and create application packages which can be depolyed to devcies to install applications"
  },
  appUnInstallProfile: {
    none: "No access to App Uninstall Profile",
    appUnInstallProfile_Read: "Read-only access to App Uninstall Profile",
    appUnInstallProfile_ReadandExport: "Read and export data from App Uninstall Profile",
    appUnInstallProfile_Fullaccess: "Full access to App Uninstall Profile with ability to export data and create application packages which can be depolyed to devcies to Uninstall applications"
  },
  appProtectProfile: {
    none: "No access to Device Protection Policies",
    appProtectProfile_Read: "Read-only access to Device Protection Policies",
    appProtectProfile_ReadandExport: "Read and export data from Device Protection Policies",
    appProtectProfile_Fullaccess: "Full access to Device Protection Policies with ability to export data and create protection policies for windows services, registry and directory."
  },
  appInstall: {
    none: "No access to Deploy app install",
    appInstall_Read: "Read-only access to Deploy app install",
    appInstall_ReadandExport: "Read and export data from Deploy app install",
    appInstall_Fullaccess: "Full access to the Deploy App Install, with ability to export data and allowing the deployment of packages created in the App Install Profile under the Automate -> Apps module."
  },
  appUnInstall: {
    none: "No access to Deploy app uninstall",
    appUnInstall_Read: "Read-only access to Deploy app uninstall",
    appUnInstall_ReadandExport: "Read and export data from Deploy app uninstall",
    appUnInstall_Fullaccess: "Full access to Deploy App uninstall, with ability to export data and allowing the deployment of packages created in the App uninstall Profile under the Automate -> Apps module."
  },
  discoverApps: {
    none: "No access to Discovered Apps",
    discoverApps_Read: "Read-only access to Discovered Apps",
    discoverApps_ReadandExport: "Read and export data from Discovered Apps"
  },
  appStatus: {
    none: "No access to Status",
    appStatus_Read: "Read-only access to Status",
    appStatus_ReadandExport: "Read and export data from Status",
    appStatus_Fullaccess: "Full access to Status"
  },
  appLog: {
    none: "No access to Activity Log",
    appLog_Read: "Read-only access to Activity Log",
    appLog_ReadandExport: "Read and export data from Activity Log"
  },
  // Trobleshoot pages
  tshootAlert: {
    none: "No access to Alerts",
    tshootAlert_Read: "Read-only access to Alerts",
    tshootAlert_ReadandExport: "Read and export data from Alerts",
    tshootAlert_Fullaccess: "Full access to Alerts, with ability to export data and allowing the user to view the alert status and deploy solutions to resolve issues on the device where the alert was triggered."
  },
  tshoot_compliancepolicy: {
    none: "No access to Compliance policy",
    tshoot_compliancepolicy_Read: "Read-only access to Compliance policy",
    tshoot_compliancepolicy_ReadandExport: "Read and export data from Compliance policy",
    tshoot_compliancepolicy_Fullaccess: "Full access to Compliance policy, with ability to export data and allowing the user to push the policy to specific Tenant or devcies"
  },
  tshoot: {
    none: "No access to Troubleshoot",
    tshoot_Read: "Read-only access to Troubleshoot",
    tshoot_ReadandExport: "Read and export data from Troubleshoot",
    tshoot_Fullaccess: "Full access to the Troubleshoot, with ability to export data and allowing the user to push the Troubleshoot to specific Tenant or devcies"
  },
  status: {
    none: "No access to Status",
    status_Read: "Read-only access to Status",
    status_ReadandExport: "Read and export data from Status",
    status_Fullaccess: "Full access to Status, with ability to export data and enabling users to view the push status of alerts, policy and troubleshoot."
  },
  // Administation pages  
  allUsers: {
    none: "No access to Users",
    allUsers_Read: "Read-only access to Users",
    allUsers_ReadandExport: "Read and export data from Users",
    allUsers_Fullaccess: "Full access to Users, with ability to export data and create new users."
  },
  administration: {
    none: "No access to Roles",
    administration_Read: "Read-only access to Roles",
    administration_ReadandExport: "Read and export data from Roles",
    administration_Fullaccess: "Full access to Roles, with ability to export data and create new Role."
  },
  tenant: {
    none: "No access to Tenant",
    tenant_Read: "Read-only access to Tenant",
    tenant_ReadandExport: "Read and export data from Tenant",
    tenant_Fullaccess: "Full access to Tenant, with ability to export data and create new Tenant."
  },
  approvals: {
    none: "No access to approvals",
    approvals_Read: "Read-only access to approvals",
    approvals_ReadandExport: "Read and export data from approvals",
    approvals_Fullaccess: "Full access to Tenant, with ability to export data and approve SSO requests."
  },
  ssoConfiguration: {
    none: "None",
    ssoConfiguration_Read: "read-only access to SSO.",
    ssoConfiguration_ReadandExport: "Read and export data from SSO.",
    ssoConfiguration_Fullaccess: "Full access to SSO, with ability to export data and create new SSO configuration"
  },
  uplad: {},
  versionUpdate: {},
  administrationLog: {
    none: "No access to Activity Log.",
    administrationLog_Read: "Read-only access to Activity Log.",
    administrationLog_ReadandExport: "Read and export data from Activity Log."
  },
  //Security page
  security_dataCollection: {
    none: "No access to Data Collection",
    security_dataCollection_Read: "Read-only access to Data Collection.",
    security_dataCollection_ReadandExport: "Read and export data from Data Collection.",
    security_dataCollection_Fullaccess: "Full access to Data Collection with ability to export data."
  },
  security_compliancepolicy: {
    none: "No access to Compliance policy.",
    security_compliancepolicy_Read: "Read-only access to Compliance policy.",
    security_compliancepolicy_ReadandExport: "Read and export data from Compliance policy.",
    security_compliancepolicy_Fullaccess: "Full access to Compliance policy, with ability to export data and allowing the user to push the policy to specific Tenant or devcies."
  },
  security_activityLog: {
    none: "No access to Activity Log.",
    security_activityLog_Read: "Read-only access to Activity log.",
    security_activityLog_ReadandExport: "Read and export data from Activity Logs."
  },
  //Search page
  asset: {
    none: "No access to Asset.",
    asset_Read: "Read-only access to Asset.",
    asset_ReadandExport: "Read and export data from Asset.",
    asset_Fullaccess: "Full access to Asset, with ability to export data and allowing the user to search."
  },
  event: {
    none: "No access to Event.",
    event_Read: "Read-only access to Event.",
    event_ReadandExport: "Read and export data from Event.",
    event_Fullaccess: "Full access to Event, with ability to export data and allowing the user to search."
  },
  //patch detection
  patchDetection: {
    none: "No access to Event.",
    patchDetection_Read: "Read-only access to Event.",
    patchDetection_ReadandExport: "Read and export data from Event.",
    patchDetection_Fullaccess: "Full access to Event, with ability to export data and allowing the user to search."
  }
};
